/* assets/lexar-commerce.js  — v3 (Option A: theme-authoritative Buy 2 Get 1)
 * ---------------------------------------------------------------------------
 * Shared commerce layer for the Lexar theme fleet.
 *
 *  1. LexarToast      header-aware toast notifications
 *  2. Add to cart     ajax add + property-marked free units + toast
 *  3. Checkout        clampGifts + property-aware payload for the external checkout
 *
 * v3 (Option A): the native automatic BXGY discount is OFF, so nothing here may
 * read discount allocations or total_discount — they are 0 everywhere. Free
 * units are decided by the THEME alone as floor(paid/2) per variant, live on ONE
 * cart line tagged properties._free_gift='true' (paid adds never send
 * properties), and are priced to zero by the lexarpep checkout portal. The cart
 * PAGE is owned by each theme's main-cart section script (grouped display,
 * fixpoint reconciler, render-once) — the v2 cart-page stepper layer is gone.
 *
 * Config: window.LEXAR_BOGO, set in layout/theme.liquid.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var CFG = window.LEXAR_BOGO || {};
  var BOGO = {
    enabled: CFG.enabled !== false,
    buy: parseInt(CFG.buy, 10) || 2,
    get: parseInt(CFG.get, 10) || 1,
    debug: CFG.debug === true
  };

  var GIFT_PROP = '_free_gift';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  ROOT = ROOT.replace(/\/$/, '');
  var URL_ADD = ROOT + '/cart/add.js';
  var URL_CHANGE = ROOT + '/cart/change.js';
  var URL_CART = ROOT + '/cart.js';
  var URL_CART_PAGE = ROOT + '/cart';

  function log() {
    if (!BOGO.debug) return;
    console.log.apply(console, ['[lexar-bogo]'].concat(Array.prototype.slice.call(arguments)));
  }

  function json(url, body) {
    log('POST', url, body);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw d;
        return d;
      });
    });
  }

  function getCart() {
    return fetch(URL_CART, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* =======================================================================
     1. TOAST
     ======================================================================= */

  var TOAST_STACK_ID = 'lexar-toast-stack';

  /* Every theme in the fleet pins its header, each with a different root. */
  var HEADER_SELECTORS = [
    '.q-header',              /* 07 quantified lab  */
    '#topbar',                /* 08 deep sea        */
    '.site-head',             /* 09 helix nine      */
    '[data-hadal-header]',
    '[data-site-header]',
    '.chrome-header',         /* 10 chrome frontier */
    '.facility-header',       /* 11 the facility    */
    '.signal-header',         /* 12 signal          */
    '.atomic-header',         /* 13 atomic cinema   */
    '.site-header',
    'header'
  ];

  function headerBottom() {
    var bottom = 0;
    for (var i = 0; i < HEADER_SELECTORS.length; i++) {
      var els = document.querySelectorAll(HEADER_SELECTORS[i]);
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        var cs = window.getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden') continue;
        var r = el.getBoundingClientRect();
        if (!r.height || r.top > 200 || r.bottom <= 0) continue;
        if (r.bottom > bottom) bottom = r.bottom;
      }
      if (bottom > 0) break;
    }
    return bottom;
  }

  function toastPosition() {
    var el = document.querySelector('[data-toast-pos]');
    var pos = el && el.getAttribute('data-toast-pos');
    return pos === 'bottom-right' ? 'bottom-right' : 'top-right';
  }

  function syncToastOffset() {
    var stack = document.getElementById(TOAST_STACK_ID);
    if (!stack) return;
    if (stack.getAttribute('data-pos') === 'bottom-right') {
      stack.style.top = '';
      stack.style.bottom = '16px';
      return;
    }
    var h = headerBottom();
    stack.style.bottom = '';
    stack.style.top = (h > 0 ? h + 14 : 16) + 'px';
  }

  function toastStack() {
    var stack = document.getElementById(TOAST_STACK_ID);
    if (!stack) {
      stack = document.createElement('div');
      stack.id = TOAST_STACK_ID;
      stack.setAttribute('role', 'status');
      stack.setAttribute('aria-live', 'polite');
      stack.setAttribute('data-pos', toastPosition());
      document.body.appendChild(stack);
    }
    syncToastOffset();
    return stack;
  }

  function dismissToast(node) {
    if (!node || node.getAttribute('data-out')) return;
    node.setAttribute('data-out', '1');
    node.classList.remove('is-in');
    window.setTimeout(function () {
      if (node.parentNode) node.parentNode.removeChild(node);
    }, 260);
  }

  var ICON_OK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_WARN =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg>';
  var ICON_GIFT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M12 8v13M3 11h18M5 11v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8M7 11V8a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v3"/></svg>';

  function showToast(opts) {
    opts = opts || {};
    var stack = toastStack();

    /* Overflow nodes are removed synchronously: dismissToast() removes on a
       timer, so looping on it here would never terminate. */
    var guard = 0;
    while (stack.children.length >= 3 && guard++ < 20) {
      var oldest = stack.firstElementChild;
      if (!oldest) break;
      oldest.setAttribute('data-out', '1');
      if (oldest.parentNode) oldest.parentNode.removeChild(oldest);
    }

    var variant = opts.variant || 'success';
    var node = document.createElement('div');
    node.className = 'lexar-toast lexar-toast--' + variant;

    var icon = variant === 'error' ? ICON_WARN : variant === 'gift' ? ICON_GIFT : ICON_OK;
    var html = '<span class="lexar-toast__ico">' + icon + '</span>';
    if (opts.image) {
      html += '<img class="lexar-toast__img" src="' + opts.image + '" alt="" width="44" height="44">';
    }
    html += '<div class="lexar-toast__body">';
    html += '<span class="lexar-toast__kicker"></span>';
    html += '<p class="lexar-toast__title"></p>';
    if (opts.link) html += '<a class="lexar-toast__link" href="' + opts.link.href + '"></a>';
    html += '</div>';
    html += '<button class="lexar-toast__x" type="button" aria-label="Dismiss">&times;</button>';
    node.innerHTML = html;

    /* Product titles are merchant data: assign as text, never as HTML. */
    node.querySelector('.lexar-toast__kicker').textContent = opts.kicker || '';
    node.querySelector('.lexar-toast__title').textContent = opts.title || '';
    if (opts.link) node.querySelector('.lexar-toast__link').textContent = opts.link.text;

    node.querySelector('.lexar-toast__x').addEventListener('click', function () {
      dismissToast(node);
    });

    stack.appendChild(node);
    window.requestAnimationFrame(function () { node.classList.add('is-in'); });

    var life = typeof opts.duration === 'number' ? opts.duration : variant === 'error' ? 5200 : 4000;
    if (life > 0) {
      var timer = window.setTimeout(function () { dismissToast(node); }, life);
      node.addEventListener('mouseenter', function () { window.clearTimeout(timer); });
      node.addEventListener('mouseleave', function () {
        timer = window.setTimeout(function () { dismissToast(node); }, 1400);
      });
    }
    return node;
  }

  window.LexarToast = {
    show: showToast,
    success: function (k, t, x) { return showToast(Object.assign({ kicker: k, title: t, variant: 'success' }, x || {})); },
    gift: function (k, t, x) { return showToast(Object.assign({ kicker: k, title: t, variant: 'gift' }, x || {})); },
    error: function (k, t, x) { return showToast(Object.assign({ kicker: k, title: t, variant: 'error' }, x || {})); },
    info: function (k, t, x) { return showToast(Object.assign({ kicker: k, title: t, variant: 'info' }, x || {})); }
  };

  window.addEventListener('scroll', syncToastOffset, { passive: true });
  window.addEventListener('resize', syncToastOffset, { passive: true });
  document.addEventListener('shopify:section:load', syncToastOffset);

  /* =======================================================================
     2. GIFT CORE (property-marked, theme-authoritative)
     ======================================================================= */

  function isGift(x) { return !!(x.properties && x.properties[GIFT_PROP] === 'true'); }

  function tallyVariant(cart, vid) {
    var t = { paid: 0, giftQty: 0, paidLines: [], gifts: [] };
    (cart.items || []).forEach(function (x) {
      if (x.variant_id !== vid) return;
      if (isGift(x)) { t.gifts.push(x); t.giftQty += x.quantity; }
      else { t.paidLines.push(x); t.paid += x.quantity; }
    });
    return t;
  }

  function freeForPaid(paid) {
    if (!BOGO.enabled) return 0;
    return Math.floor(paid / BOGO.buy) * BOGO.get;
  }

  function cartAdd(vid, qty, gift) {
    var body = { items: [{ id: vid, quantity: qty }] };
    if (gift) { var props = {}; props[GIFT_PROP] = 'true'; body.items[0].properties = props; }
    return json(URL_ADD, body);
  }

  function cartChange(key, qty) {
    return json(URL_CHANGE, { id: key, quantity: qty });
  }

  /* buy 2 get 1 free — THEME-authoritative fixpoint reconciler. Free units are
     floor(paid/2), live on lines tagged properties._free_gift='true', priced to
     zero at the lexarpep checkout hand-off. Each pass re-reads /cart.js and does
     AT MOST ONE mutation, correcting TOTALS only: 1) restore the paid total the
     customer built, 2) raise the gift total to floor(paid/2), 3) trim gift
     overage. It NEVER consolidates split lines: while the native discount is
     still enabled the engine re-splits a variant after every merge, so fighting
     it oscillates, storms the API into Shopify's 429 bot-verification page, and
     an interrupted restore is what loses quantities. Split lines are grouped by
     the DISPLAY instead. */
  function reconcileGift(vid) {
    if (!vid) return Promise.resolve(null);
    var intended = -1, giftStart = 0;
    function pass(left) {
      return getCart().then(function (cart) {
        var t = tallyVariant(cart, vid);
        if (intended < 0) { intended = t.paid; giftStart = t.giftQty; }
        var target = freeForPaid(intended);
        var op = null;
        if (t.paid < intended) {
          if (t.paidLines.length > 0) op = function () { return cartChange(t.paidLines[0].key, t.paidLines[0].quantity + (intended - t.paid)); };
          else op = function () { return cartAdd(vid, intended - t.paid, false); };
        } else if (t.giftQty < target) {
          if (t.gifts.length > 0) op = function () { return cartChange(t.gifts[0].key, t.gifts[0].quantity + (target - t.giftQty)); };
          else op = function () { return cartAdd(vid, target, true); };
        } else if (t.giftQty > target) {
          var lastG = t.gifts[t.gifts.length - 1];
          var cut = Math.min(t.giftQty - target, lastG.quantity);
          op = function () { return cartChange(lastG.key, lastG.quantity - cut); };
        }
        if (!op || left <= 0) return t.giftQty;
        return op().catch(function () {}).then(function () { return pass(left - 1); });
      });
    }
    return pass(8).then(function (giftFinal) { return { added: giftFinal - giftStart }; }).catch(function () { return null; });
  }

  function updateCartCounts(cart) {
    var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (n === null) return;
    document.querySelectorAll('[data-cart-count], #cartCount, #cartBadge').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('zero', n === 0);
    });
  }

  var queue = Promise.resolve();
  function enqueue(fn) {
    queue = queue.then(fn).catch(function (err) { console.error('[lexar-commerce]', err); });
    return queue;
  }

  /* =======================================================================
     3. ADD TO CART
     ======================================================================= */

  function handleAdd(form, button) {
    var data = new FormData(form);
    var variantId = data.get('id');
    if (!variantId) return;

    var label = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    enqueue(function () {
      return fetch(URL_ADD, { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw d;
            return d;
          });
        })
        .then(function () { return reconcileGift(Number(variantId)); })
        .then(function (g) {
          return getCart().then(function (cart) {
            updateCartCounts(cart);
            var agg = tallyVariant(cart, Number(variantId));
            var li = agg.paidLines[0] || agg.gifts[0] || null;
            var title = li ? li.product_title : '';
            var img = li ? li.image : null;
            var viewCart = { href: URL_CART_PAGE, text: 'View cart' };

            if (g && g.added > 0) {
              window.LexarToast.gift(
                'Buy ' + BOGO.buy + ' Get ' + BOGO.get + ' Free applied',
                title + ' — ' + agg.paid + ' paid, ' + agg.giftQty + ' free',
                { image: img, link: viewCart }
              );
            } else {
              window.LexarToast.success('Added to cart',
                title + (agg.paid > 1 ? ' — ' + agg.paid + ' paid' : ''),
                { image: img, link: viewCart });
            }
            document.dispatchEvent(new CustomEvent('lexar:cart:updated', { detail: { cart: cart } }));
          });
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || 'Could not add this item.';
          window.LexarToast.error('Not added', msg);
          log('add failed', err);
        })
        .then(function () {
          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            if (label) button.textContent = label;
          }
        });
    });
  }

  /* Capture phase so this beats each theme's own click handler. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var button = e.target.closest('form[action*="/cart/add"] [type="submit"]');
    if (!button || button.disabled) return;
    var form = button.form || button.closest('form');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handleAdd(form, button);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handleAdd(form, form.querySelector('[type="submit"]'));
  }, true);

  /* The cart page itself is owned by the main-cart section script (grouped
     display, variant-total stepper, fixpoint reconciler, render-once). The
     only page-level guard left: never let the cart form POST natively. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart') === -1 || action.indexOf('/cart/add') !== -1) return;
    e.preventDefault();
  });

  /* =======================================================================
     4. CHECKOUT HAND-OFF
     ======================================================================= */

  /* Trim any gift units beyond floor(paid/2) per variant (stale state from an
     interrupted reconcile), then re-read the cart so the encoded lines match
     exactly what the portal will zero. */
  function clampGifts(cart) {
    var byVid = {};
    (cart.items || []).forEach(function (li) {
      var v = byVid[li.variant_id] = byVid[li.variant_id] || { paid: 0, gifts: [] };
      if (isGift(li)) v.gifts.push(li);
      else v.paid += li.quantity;
    });
    var ops = [];
    Object.keys(byVid).forEach(function (vid) {
      var v = byVid[vid];
      var giftQty = v.gifts.reduce(function (s, l) { return s + l.quantity; }, 0);
      var allowed = freeForPaid(v.paid);
      var over = giftQty - allowed;
      for (var i = v.gifts.length - 1; i >= 0 && over > 0; i--) {
        var cut = Math.min(over, v.gifts[i].quantity);
        ops.push({ id: v.gifts[i].key, quantity: v.gifts[i].quantity - cut });
        over -= cut;
      }
    });
    if (!ops.length) return Promise.resolve(cart);
    return ops.reduce(function (p, op) {
      return p.then(function () {
        return cartChange(op.id, op.quantity).catch(function () {});
      });
    }, Promise.resolve()).then(getCart);
  }

  /* The external checkout charges the unitPrice we send: property-flagged gift
     lines encode 0.00 (bounded by clampGifts), everything else its final price.
     The properties ride along so the portal can also see the flag. */
  function mapItems(cart) {
    return (cart.items || []).map(function (li) {
      var free = isGift(li);
      return {
        id: li.variant_id,
        name: free ? li.product_title + ' (Free)' : li.product_title,
        variant: li.variant_title || '',
        image: li.image || '',
        quantity: li.quantity,
        unitPrice: free ? '0.00' : ((li.final_price != null ? li.final_price : li.price) / 100).toFixed(2),
        lineTotal: free ? '0.00' : ((li.final_line_price || 0) / 100).toFixed(2),
        freeUnit: free,
        properties: li.properties || {}
      };
    });
  }

  window.LexarCart = window.LexarCart || {};
  window.LexarCart.mapItems = mapItems;
  window.LexarCart.getCart = getCart;
  window.LexarCart.clampGifts = clampGifts;
  window.LexarCart.reconcileGift = reconcileGift;
  window.LexarCart.tallyVariant = tallyVariant;
  window.LexarCart.freeForPaid = freeForPaid;
  window.LexarCart.updateCartCounts = updateCartCounts;
  window.LexarCart.config = BOGO;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncToastOffset);
  } else {
    syncToastOffset();
  }
})();
